import { useState, useEffect } from 'react';
import { BsThreeDotsVertical, BsThreeDots } from 'react-icons/bs';

const Menu = ({ children, setShow }) => {
  const handleOutsideClick = () => setShow(false);

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);

    return function cleanup() {
      document.removeEventListener('click', handleOutsideClick);
    };
  });

  return (
    <div className="shadow bg-white position-absolute top-5 mt-2 end-0" style={{ minWidth: 150 }}>
      <ul className="dropdown-menu position-absolute top-5 end-0 shadow show">{children}</ul>
    </div>
  );
};

const DotMenu = ({ children, vertical, color }) => {
  const [show, setShow] = useState(false);

  const showMenu = () => setShow(!show);
  const menu = show ? <Menu children={children} setShow={setShow} /> : null;

  const Icon = vertical ? BsThreeDotsVertical : BsThreeDots;

  return (
    <div className="position-relative">
      <button className="btn btn-icon" type="button" onClick={showMenu}>
        <Icon size={22} color={color} />
      </button>

      {menu}
    </div>
  );
};

export default DotMenu;
